import React from "react";
// @ts-ignore
import "./WhatsAppButton.css";

const WHATSAPP_URL =
  "https://wa.me/19294526031?text=" +
  encodeURIComponent(
    "Hi GS Limo Elite, I would like a quote for a ride. Pickup, drop-off, date and time:",
  );

export default function WhatsAppButton(): JSX.Element {
  return (
    <a
      className="gs-wa"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with GS Limo Elite on WhatsApp"
      title="Chat with GS Limo Elite on WhatsApp"
    >
      <i className="fab fa-whatsapp" aria-hidden="true"></i>
      <span className="gs-wa-label">WhatsApp</span>
    </a>
  );
}
